import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HeroSection() {
  const featuredArticle = articles.find((a) => a.featured && a.trending) || articles[0];

  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20entertainment%20news%20studio%20background%20with%20warm%20red%20and%20dark%20tones%2C%20cinematic%20paparazzi%20flash%20lights%2C%20abstract%20spotlight%20beams%2C%20modern%20media%20broadcast%20atmosphere%2C%20breaking%20news%20aesthetic%2C%20red%20carpet%20texture%20elements%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20luxurious%20velvet%20curtain%20texture&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="黑料不打烊 - 娱乐圈爆料"
        title="黑料不打烊 娱乐圈黑料 明星爆料"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 md:px-6">
        <div className="w-full max-w-3xl text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-xs font-medium mb-4 md:mb-6">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse"></span>
            重磅爆料
          </div>
          <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight mb-3 md:mb-4">
            <Link to={`/article/${featuredArticle.slug}`} className="text-white no-underline hover:text-primary-200 transition-colors">
              {featuredArticle.title}
            </Link>
          </h1>
          <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-5 md:mb-6 line-clamp-2">
            {featuredArticle.excerpt}
          </p>
          <div className="flex items-center justify-center gap-3 mb-5 md:mb-6">
            <span className="text-xs text-white/60 flex items-center gap-1">
              <i className="ri-time-line"></i>
              {featuredArticle.date}
            </span>
            <span className="text-xs text-white/60 flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {(featuredArticle.views / 10000).toFixed(1)}万阅读
            </span>
            <span className="px-2 py-0.5 rounded bg-accent-500/80 text-white text-xs whitespace-nowrap">
              {featuredArticle.category}
            </span>
          </div>
          <Link
            to={`/article/${featuredArticle.slug}`}
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium transition-all whitespace-nowrap"
          >
            立即查看
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}